<template>
  <div class="main-layout__box">
    <div
      class="main-layout__item main-layout__item_head main-layout__item_hover main-layout__item_p12"
    >
      <div class="w-3 t-c foz-23">#</div>
      <div class="w-4"></div>
      <div class="w-11">{{ $t("listsHeader.full_name") }}</div>
      <div class="w-10">{{ $t("listsHeader.phone") }}</div>
      <div class="w-15">{{ $t("listsHeader.email") }}</div>
      <div class="w-30">{{ $t("listsHeader.address") }}</div>
      <div class="main-layout__item-actions">
        {{ $t("listsHeader.actions") }}
      </div>
    </div>

    <transition-group
      name="list"
      tag="div"
      class="main-layout__list main-layout__list_mxh87"
    >
      <div
        v-for="user in usersData"
        :key="user.id"
        class="main-layout__item main-layout__item_hover"
        :class="{
          show: showSubItems === user.id,
          delete: user.deletion_tag,
          userlist__item_new: !user.is_read,
        }"
      >
        <div class="w-3 t-c">{{ user.original_id }}</div>
        <div class="w-4 main-layout__item-image">
          <img :src="getImage(user.small_image)" alt />
        </div>
        <div
          class="w-11 cut-text"
          :title="user.first_name + ' ' + user.last_name"
        >
          <span>{{ user.first_name }} {{ user.last_name }}</span>
        </div>
        <div class="w-10" :title="user.phone">
          <span>{{ user.phone }}</span>
        </div>
        <div class="w-15" :title="user.email">
          <span>{{ user.email }}</span>
        </div>

        <div class="w-30 user-address">
          <div class="user-address__head">
            <div v-if="user.addresses.length <= 1">
              <span v-if="user.addresses[0]">
                {{
                  user.addresses[0].street +
                    ", " +
                    user.addresses[0].house +
                    ", " +
                    user.addresses[0].apartment +
                    ", " +
                    user.addresses[0].country +
                    ", " +
                    user.addresses[0].city
                }}
              </span>
              <span v-else>-</span>
            </div>

            <div
              v-else
              class="user-address__multiple"
              @click="toggleSubItems($event, user.id)"
            >
              <span v-if="showSubItems !== user.id">
                {{ $t("lists.showAddresses") }}
              </span>
              <span v-else>{{ $t("lists.hide") }}</span>
              <img
                class="user-address__img"
                :class="{ 'user-address__img_show': showSubItems === user.id }"
                src="/images/icon/triangle.svg"
                alt
              />
            </div>
          </div>

          <template v-if="user.addresses.length > 1">
            <div class="user-address__body" v-if="showSubItems === user.id">
              <div
                class="user-address__item"
                v-for="address in user.addresses"
                :key="address.a"
              >
                <span>
                  {{
                    address.street +
                      ", " +
                      address.house +
                      ", " +
                      address.apartment +
                      ", " +
                      address.country +
                      ", " +
                      address.city
                  }}
                </span>
              </div>
            </div>
          </template>
        </div>

        <div class="main-layout__item-actions">
          <div v-if="$guard('read', 'Chat')" @click="openChat(user.id)">
            <svg
              id="open-chat"
              class="main-layout__item-icon"
              height="24px"
              viewBox="-21 -47 682.66669 682"
              width="24px"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="var(--bg-color-green)"
                d="m552.011719-1.332031h-464.023438c-48.515625 0-87.988281 39.464843-87.988281 87.988281v283.972656c0 48.414063 39.300781 87.816406 87.675781 87.988282v128.863281l185.191407-128.863281h279.144531c48.515625 0 87.988281-39.472657 87.988281-87.988282v-283.972656c0-48.523438-39.472656-87.988281-87.988281-87.988281zm50.488281 371.960937c0 27.835938-22.648438 50.488282-50.488281 50.488282h-290.910157l-135.925781 94.585937v-94.585937h-37.1875c-27.839843 0-50.488281-22.652344-50.488281-50.488282v-283.972656c0-27.84375 22.648438-50.488281 50.488281-50.488281h464.023438c27.839843 0 50.488281 22.644531 50.488281 50.488281zm0 0"
              />
              <path
                fill="var(--bg-color-green)"
                d="m171.292969 131.171875h297.414062v37.5h-297.414062zm0 0"
              />
              <path
                fill="var(--bg-color-green)"
                d="m171.292969 211.171875h297.414062v37.5h-297.414062zm0 0"
              />
              <path
                fill="var(--bg-color-green)"
                d="m171.292969 291.171875h297.414062v37.5h-297.414062zm0 0"
              />
            </svg>
          </div>

          <call-btn :user="user" type="clients" />

          <div>
            <svg
              class="main-layout__item-icon"
              @click="openClientModal(user.id)"
            >
              <use xlink:href="/images/svg/symbols.svg#svg-user-message" />
            </svg>
          </div>
          <div v-if="role !== 'partner-admin'" @click="deleteOpen(user)">
            <svg class="main-layout__item-icon">
              <use xlink:href="/images/svg/symbols.svg#svg-user-del" />
            </svg>
          </div>

          <!-- <div @click="openEmailModal(user.email)">
            <svg
              class="main-layout__item-icon"
              id="Capa_1"
              enable-background="new 0 0 479.058 479.058"
              height="24px"
              viewBox="0 0 479.058 479.058"
              width="24px"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="var(--bg-color-green)"
                d="m434.146 59.882h-389.234c-24.766 0-44.912 20.146-44.912 44.912v269.47c0 24.766 20.146 44.912 44.912 44.912h389.234c24.766 0 44.912-20.146 44.912-44.912v-269.47c0-24.766-20.146-44.912-44.912-44.912zm0 29.941c2.034 0 3.969.422 5.738 1.159l-200.355 173.649-200.356-173.649c1.769-.736 3.704-1.159 5.738-1.159zm0 299.411h-389.234c-8.26 0-14.971-6.71-14.971-14.971v-251.648l199.778 173.141c2.822 2.441 6.316 3.655 9.81 3.655s6.988-1.213 9.81-3.655l199.778-173.141v251.649c-.001 8.26-6.711 14.97-14.971 14.97z"
              />
            </svg>
          </div> -->

          <div @click="openRequestModal(user)">
            <svg class="main-layout__item-icon">
              <use xlink:href="/images/svg/symbols.svg#svg-add-work" />
            </svg>
          </div>

          <div v-if="user.is_client_problem_messages">
            <svg
              @click="openTodoList(user)"
              id="Layer_1_1_"
              viewBox="0 0 64 64"
              xmlns="http://www.w3.org/2000/svg"
              fill="var(--bg-color-green)"
              class="main-layout__item-icon"
            >
              <path
                d="m8 19h8c.55225 0 1-.44775 1-1v-3h-2v2h-6v-6h3v-2h-4c-.55225 0-1 .44775-1 1v8c0 .55225.44775 1 1 1z"
              />
              <path
                d="m12 13.58594-1.29297-1.29297-1.41406 1.41406 2 2c.19531.19531.45117.29297.70703.29297s.51172-.09766.70703-.29297l6-6-1.41406-1.41406z"
              />
              <path
                d="m15 30h-6v-6h3v-2h-4c-.55225 0-1 .44775-1 1v8c0 .55225.44775 1 1 1h8c.55225 0 1-.44775 1-1v-3h-2z"
              />
              <path
                d="m12 26.58594-1.29297-1.29297-1.41406 1.41406 2 2c.19531.19531.45117.29297.70703.29297s.51172-.09766.70703-.29297l6-6-1.41406-1.41406z"
              />
              <path
                d="m16 35h-8c-.55225 0-1 .44775-1 1v8c0 .55225.44775 1 1 1h8c.55225 0 1-.44775 1-1v-8c0-.55225-.44775-1-1-1zm-1 8h-6v-6h6z"
              />
              <path
                d="m16 48h-8c-.55225 0-1 .44775-1 1v8c0 .55225.44775 1 1 1h8c.55225 0 1-.44775 1-1v-8c0-.55225-.44775-1-1-1zm-1 8h-6v-6h6z"
              />
              <path
                d="m57.70703 5.29297c-.39062-.39062-1.02344-.39062-1.41406 0l-6.29297 6.29297-9.29297-9.29297c-.1875-.1875-.44189-.29297-.70703-.29297h-37c-.55225 0-1 .44775-1 1v58c0 .55225.44775 1 1 1h47c.55225 0 1-.44775 1-1v-39.58594l10.70703-10.70703c.39062-.39062.39062-1.02344 0-1.41406zm-8.70703 54.70703h-45v-56h35.58594l8 8h-6.58594v-5h-2v6c0 .55225.44775 1 1 1h7.58594l-23.29297 23.29297c-.10986.10986-.19238.24365-.2417.39062l-2 6c-.11963.35938-.02637.75586.2417 1.02344.19043.19092.44629.29297.70703.29297.10596 0 .2124-.0166.31641-.05127l6-2c.14697-.04932.28076-.13184.39062-.2417l19.29297-19.29297zm-23.56299-20.14893 1.71191 1.71191-2.56787.85596zm3.56299.73487-2.58594-2.58594 30.58594-30.58594 2.58594 2.58594z"
              />
              <path d="m45 56h2v2h-2z" />
              <path d="m41 56h2v2h-2z" />
              <path d="m37 56h2v2h-2z" />
            </svg>
          </div>

          <div>
            <delete-request
              v-if="$guard('delete', 'Clients') && user.deletion_tag"
              :item="user"
              :type="'clients'"
              @save="fetchClients"
              @remove="deleteOpenAdapter"
            />
          </div>
        </div>
      </div>
    </transition-group>

    <div class="userlist__item" v-if="usersData.length === 0">
      {{ $t("lists.listEmpty") }}
    </div>

    <modal
      :show="modal"
      @close="setClientModal(false)"
      :dark="true"
      :outside="false"
    >
      <client-modal
        @close="setClientModal(false)"
        @openRequestModal="openRequestModal"
      />
    </modal>

    <modal
      :show="showModalDelete"
      :showBtn="false"
      :dark="true"
      :outside="false"
      @close="closeModal"
    >
      <delete-modal
        :title="$t('lists.deleteMessage')"
        :cancelDeletionTag="deletionStatus && !$guard('write', 'Clients')"
        @cancel="closeModal"
        @next="removeAction"
      />
    </modal>

    <modal
      :show="showMails"
      @close="toggleMailsModal"
      :outside="false"
      :dark="true"
    >
      <send-mail @close="toggleMailsModal" />
    </modal>
  </div>
</template>

<script>
import animateScrollTo from 'animated-scroll-to'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import clientModal from '@/components/modals/client/clientModal'
import deleteRequest from '@/components/controls/deleteRequest'
import sendMail from '@/components/modals/mails/sendMail'
import callBtn from '@/components/lists/clients/clientsCallBtn/index'
import debounce from '@/utils/debounce'

export default {
    components: {
        clientModal,
        deleteRequest,
        sendMail,
        callBtn,
    },
    data() {
        return {
            showModalDelete: false,
            id: '',
            showSubItems: false,
            subItemPadding: '',
            showModalEmployee: false,
            typeAction: '',
            typeEmployee: '',
            companyId: '',
            deleteTitle: '',
            companyImage: '',
            edit: '',
            defaultImage: '/images/default-user.svg',
            role: window.$role,
        }
    },
    computed: {
        ...mapGetters({
            modal: 'clientModalGetters',
            showMails: 'mails/showModalGetters',
            deletionStatus: 'clientDeletionStatusGetters',
            params: 'clientParams',
        }),
        usersData() {
            return this.$store.state.clients.data
        },
    },
    methods: {
        ...mapActions({
            readClient: 'readClient',
            fetchById: 'fetchById',
            requestForDelete: 'deleteControl/requestForDelete',
            getClientsData: 'getClientsData',

            fetchClientRequests: 'fetchClientRequests',
        }),
        ...mapMutations({
            setClientModal: 'setClientModal',
            toggleMailsModal: 'mails/setShowModal',
            setEmail: 'mails/setEmail',
            setDeletionStatus: 'setClientsDeletionStatus',
            setClientModalType: 'setClientModalType',
            setContact: 'requests/setContact',
            setFormData: 'requests/setFormData',
            toggleShowRequestModalAdd: 'requests/toggleShowModalAdd',
        }),
        openClientModal: debounce(async function fn(id) {
            this.setClientModalType('edit')

            await this.fetchById(id)
            await this.fetchClientRequests(id)

            this.setClientModal(true)
        }, 2000),
        openChat(id) {
            this.$router.push({ name: 'chat', params: { id, type: 'clients' } })
        },
        openTodoList({ id }) {
            this.$router.push({ name: 'todo', query: { id } })
        },
        closeModal() {
            this.showModalEmployee = false
            this.showModalDelete = false
        },
        deleteOpenAdapter(id) {
            this.deleteOpen({
                id,
                deletion_tag: false,
            })
        },
        deleteOpen({ id, deletion_tag }) {
            this.setDeletionStatus(deletion_tag)
            this.showModalDelete = true
            this.id = id
        },
        removeAction() {
            this.showModalDelete = false
            this.deleteClient(this.id)
        },
        toggleSubItems(event, id) {
            if (this.showSubItems === id) {
                this.showSubItems = false
            } else {
                this.showSubItems = id
                setTimeout(() => {
                    let offSetEl = 0
                    const closestEl = event.target.closest('.userlist__item-wrapper')
                    if (closestEl) {
                        offSetEl = closestEl.offsetTop
                    }
                    const itemBox = document.querySelector('.userlist__block')
                    let itemboxScrollTop = 0
                    if (itemBox) {
                        itemboxScrollTop = itemBox.scrollTop
                    }
                    if (offSetEl < itemboxScrollTop) {
                        animateScrollTo(offSetEl, { speed: 1000, element: itemBox })
                    }
                }, 500)
            }
        },
        handleResize() {
            this.subItemPadding = document.querySelector('.js-address')
                ? document.querySelector('.js-address').offsetLeft
                : ''
        },
        addCompanyOpen(clientId) {
            this.$store.commit('udpateObject', { data: 'employeeData' })
            this.$emit('getClientData', clientId)
            this.showModalEmployee = true
            this.typeAction = 'company'
            this.id = clientId
            this.edit = false
            this.typeEmployee = this.newCompanyTitle
        },
        getImage(image) {
            return `${image === null ? this.defaultImage : image}`
        },
        empoloyeeConfirm() {
            this.$emit('addCompany', this.id)
        },
        setAvatarConfirm(data, type) {
            this.$emit('setEmployeeAvatar', data, type)
        },
        updateAvatarConfirm(data) {
            this.$emit('updateEmployeeAvatar', this.companyId, this.id, data)
        },
        setAvatarCompanyConfirm(data) {
            this.$emit('setCompanyAvatar', data)
        },
        updateAvatarCompanyConfirm(data) {
            this.$emit('updateCompanyAvatar', this.companyId, data)
        },
        async deleteClient(id) {
            this.$Progress.start()

            if (!this.$guard('delete', 'Clients')) {
                await this.requestForDelete({
                    id,
                    type: 'clients',
                })
                await this.getClientsData({ params: this.params })
                this.$Progress.finish()
                return
            }

            await this.$store.dispatch('deleteClient', id)
            this.$Progress.finish()
        },
        // async openClientModal(id) {
        //   this.setClientModalType("edit");

        //   await this.fetchById(id);
        //   await this.fetchClientRequests(id);
        //   this.setClientModal(true);
        // },
        async fetchClients() {
            await this.getClientsData({})
        },
        openEmailModal(email) {
            this.toggleMailsModal()
            this.setEmail(email)
        },
        setRequestFormData(client) {
            this.setFormData({ key: 'final_price', value: 0 })
            this.setFormData({ key: 'duration', value: '01:00' })
            this.setFormData({ key: 'description', value: '' })
            this.setFormData({ key: 'images', value: [] })

            const hasOrders = client.addresses && client.addresses.length > 0

            if (hasOrders) {
                const address = client.addresses[0]

                this.setFormData({
                    key: 'address',
                    value: {
                        house: address.house,
                        street: address.street,
                        postcode: address.postcode,
                        city: address.city,
                        country: address.country,
                        latitude: address.latitude,
                        longitude: address.longitude,
                        apartment: address.apartment,
                    },
                })
            }
        },
        openRequestModal(client) {
            this.setContact(client)
            this.setRequestFormData(client)
            this.toggleShowRequestModalAdd()
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize)
        this.subItemPadding = document.querySelector('.js-address')
            ? document.querySelector('.js-address').offsetLeft
            : ''

        this.usersData.forEach((element) => {
            if (!element.is_read) {
                this.readClient({ id: element.id, is_read: element.is_read })
            }
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
    },

    destroyed() {
        this.setClientModal(false)
    },
}
</script>

<style lang="scss" scoped>
.user-address {
  &__head {
    height: 24px;
    display: flex;
    align-items: center;
  }

  &__multiple {
    cursor: pointer;
    color: var(--bg-color-green);
    display: flex;
    align-items: center;
  }

  &__item {
    margin-bottom: 6px;
  }

  &__img {
    display: inline-block;
    margin-left: 8px;
    width: 10px;
    height: 10px;

    &_show {
      transform: rotate(180deg);
    }
  }
}
</style>
